<template>
    <v-dialog
        transition="dialog-top-transition"
        max-width="650"
        v-model="isOpenDeleteDialog"
    >
        <v-card class="pt-2 pb-1">
            <div class="d-flex justify-space-between px-4">
                <h1 class="px-3 font-weight-light text-center">
                    ¿Está seguro de que quiere borrar este elemento?
                </h1>
                <v-icon size="90" color="orange">
                    mdi-alert
                </v-icon>
            </div>
            <div class="pt-4">
                <p class="px-6 font-weight-light text-center">
                    <v-icon color="red">mdi-delete</v-icon>
                    Recuerde proceder con cautela, este cambio podría ser irreversible  y afectar a la consistencia en los datos ya existentes en la base de datos. Consulte con los administradores si no está seguro de lo que está haciendo.
                </p>
                
            </div>

            <v-card-actions class="justify-end">
                <v-btn text color="red" @click="closeForm">
                    Cerrar
                </v-btn>
                <v-btn color="red" dark @click="confirmDelete()">
                    Borrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
export default {

    name: 'DeviceDelete',
    methods: {
        closeForm() {
            this.$store.commit('deviceManagement/isOpenDeleteDialog', false);
        },
        confirmDelete(){
            let toDeleteId = this.$store.state.deviceManagement.deleteObject.toDeleteId
            let toDeleteType = this.$store.state.deviceManagement.deleteObject.toDeleteType

            if(toDeleteType == 'INSTALLMENT'){
                this.deleteInstallment(toDeleteId)
            }
            else if(toDeleteType == 'DEVICE'){
                this.deleteDevice(toDeleteId)
            }

            this.closeForm()
        },
        ...mapActions('deviceManagement', ['deleteInstallment', 'deleteDevice']),

    },
    computed: {
        isOpenDeleteDialog: {
            get() {
                return this.$store.state.deviceManagement.deleteObject.isOpenDeleteDialog;
            },
            set(val) {
                this.$store.commit('deviceManagement/isOpenDeleteDialog', val);
            },
        },
    },
};
</script>
